export const ScreenName = {
  WalkThrough: 'A-1.ウォークスルー',
  Registration: 'A-2.アカウント登録',
  DataInherit: 'A-3.会員IDの引き継ぎ',
  DataInheritInput: 'A-4.会員IDの入力',
  InvitationLp: 'A-5.招待',
  LineLogin: 'A-6.LINEアカウント連携とは',

  Home: 'B-0.Home',
  HomeDetail: 'B-1.News詳細',

  Prizes: 'C-1.特典一覧',
  StampHistory: 'C-2.スタンプ獲得履歴',
  StampHistoryMonthly: 'C-3.これまでの月間スタンプランキング',
  StampHistoryCard: 'C-4.スタンプ獲得履歴詳細',

  Coupon: 'D-0.クーポン',
  useCoupon: 'D-1.クーポン詳細',

  NetShop: 'F-1.ネットショップ',

  FAQ: 'G-0.よくある質問',
  FAQBasicSetting: 'G-1.基本設定',
  FAQCollectStamp: 'G-2.スタンプを貯めよう',
  FAQUseCoupon: 'G-3.クーポンを使ってみよう',
  FAQStamp: 'G-4.スタンプがつかない',
  FAQReadError: 'G-5.読み込みエラーになる場合',
  FAQAppSetting: 'G-6.アプリ設定',
  FAQContact: 'G-7.お問い合わせ',
  FAQModelChange: 'G-7.機種変更の手続きについて',
  FAQInvitation: 'G-8.アプリをお友だちに紹介',
  FAQAndroid: 'G-9.Android端末で最新版のアプリにアップデートできない',
  FAQInquiry: 'G-10.お問合わせ',
  FAQNextAndroid: 'G-11.次回アップデートについて',
  FAQPremium: 'G-12.香の川製麺プレミアムラウンジ',
  AboutWalk: 'G-13.ウォークスタンプについて',
  FAQStampSupport: 'G-14.スタンプサポートが使えない',
  WalkFAQ: 'G-15.ウォークスタンプ Q&A',
  LoginBonusFQQ: 'G-16.ログインボーナスについて',
  FAQInvitationInfo: 'G-17.アプリをお友だちに紹介',
  FAQiOS: 'G-18.iOS端末で最新版のアプリにアップデートできない',
  FAQSealCollection: 'G-19.シールコレクション',

  ProfileSetting: 'K-0.プロフィール更新',

  PremiumInterlude: 'L-0.プレミアムラウンジ',
  PremiumCoupon: 'L-1.プレミアムラウンジ',

  Walk: 'M-0.ウォークスタンプ',

  loginBonus: 'N-0.ログインボーナス',
  loginBonusHistory: 'N-1.これまでに食べたもの & お知らせ',
  errorMessage: 'O-0.エラーメッセージ',

  MyPage: 'P-0.マイページ',
  Delivery: 'Q-0.宅配サービス',
  TakeOut: 'R-0.テイクアウト',
  NetOrder: 'S-0.ネット通販',
  SealCollection: 'T-0.シールコレクション',
}

export const ContentsType = {
  InfoImportant: 'Info_Important',
  InfoNews: 'Info_News',
  InfoNewsExternalLink: 'Info_News_External_Link',
  InfoPopupClose: 'Info_Popup_Close',
  InfoPopupDetail: 'Info_Popup_Detail',

  SealCondition: 'Seal_Condition',

  CouponCondition: 'Coupon_Condition',
  CouponUse: 'Coupon_Use',
  FreepassUse: 'Freepass_Use',
  CouponUseDetail: 'Coupon_Use_Detail',
  CouponUseConfirm: 'Coupon_Use_Confirm',
  CouponUseCancel: 'Coupon_Use_Cancel',
  CouponClose: 'Coupon_Close',

  ProfileUpdate: 'Profile_Update',
  Account: 'Account_Register',

  ToRegistration: 'To_Registration',
  InvitationSuccessClose: 'Invitation_Success_Close',
  InvitationFailureClose: 'Invitation_Failure_Close',

  FAQUseCoupon: 'FAQ_Use_Coupon',
  FAQBasicSetting: 'FAQ_Basic_Setting',
  FAQCollectStamp: 'FAQ_Collect_Stamp',
  FAQHelpStamp: 'FAQ_Help_Stamp',
  FAQErrorHttp: 'FAQ_Error_Http',
  FAQQuestions: 'FAQ_Questions',
  FAQContact: 'FAQ_Contact',
  FAQQRStamp: 'FAQ_QRStamp',
  FAQModelChange: 'FAQ_Model_Change',
  FAQAndroid: 'FAQ_Android',
  FAQNextAndroid: 'FAQ_Next_Android',
  FAQPremium: 'FAQ_Premium',
  FAQPremiumClose: 'FAQ_Premium_Close',
  FAQStampSupportBug: 'FAQ_Stamp_Support_Bug',
  FAQLineLogin: 'FAQ_Line_Login',
  FAQSIWA: 'FAQ_SIWA',
  FAQAccountDelete: 'FAQ_Account_Delete',
  FAQTop: 'FAQ_TOP',

  Prizes: 'Prizes',
  FAQLoginBonus: 'FAQ_Login_Bonus',
  FAQResetStamp: 'FAQResetStamp',
  FAQiOS: 'FAQ_iOS',
  FAQiOS530: 'FAQ_iOS530',
  FAQInvitation: 'FAQ_Invitation',
  FAQWalk: 'FAQ_Walk',
  FAQWalkQA: 'FAQ_Walk_QA',
  FAQInquiry: 'FAQ_Inquiry',

  SendMail: 'Send_Mail',

  SettingApp: 'Setting_App',
  SettingApp1: 'Setting_App_1',
  SettingApp2: 'Setting_App_2',
  SettingApp3: 'Setting_App_3',
  QRCamera: 'QR_Camera',
  StampSupport: 'Stamp_Support',
  GotoCoupon: 'Goto_Coupon',
  ModelChangeSendId: 'Model_Change_Send_Id',
  GetScreenShot: 'Get_Screen_Shot',
  Walk: 'Walk',
  MyPage: 'MyPage',
  Loginbonus: 'Loginbonus',
  LoginbonusHistory: 'Loginbonus_History',
  DataInherit: 'Data_Inherit',
  DataInheritInput: 'Data_Inherit_Input',
  InheritUser: 'Inherit_User',

  LineLogin: 'Line_Login',
  SIWA: 'SIWA',

  WalkThrough: 'Walk_Through',
  StampHistory: 'Stamp_History',
  StampHistoryCard: 'Stamp_History_Card',
  StampHistoryMonthly: 'Stamp_History_Monthly',
  PremiumCoupon: 'Premium_Coupon',

  InvitationAlertOpen: 'Invitation_Alert_Open',
  InvitationAlertClose: 'Invitation_Alert_Close',
  InvitationUpperLimitAlertClose: 'Invitation_Upper_Limit_Alert_Close',
  SendInvitation: 'Send_Invitation',

  AccountDeleteAlertOpen: 'AccountDelete_Alert_Open',
  AccountDeleteAlertClose: 'AccountDelete_Alert_Close',
  SendAccountDelete: 'Send_AccountDelete',
  AccountDelete: 'AccountDelete',
  AboutWalk: 'About_Walk',
  ReloadWalk: 'Reload_Walk',
  ThisWeekWalk: 'This_Week_Walk',
  WeeklyWalk: 'Weekly_Walk',
  MonthlyWalk: 'Monthly_Walk',

  NetShop: 'Net_Shop',
  Delivery: 'Delivery_Service',

  Joychan: 'Joychan',
  Menu: 'Menu',
  RevokeLineLoginOpen: 'Revoke_Line_Login_Open',
  RevokeLineLogin: 'Revoke_Line_Login',
  RevokeLineLoginClose: 'Revoke_Line_Login_Close',
  CompleteRevokeLineLoginClose: 'Complete_Revoke_Line_Login_Close',

  RevokeUserSIWAOpen: 'Revoke_User_SIWA_Open',
  RevokeUserSIWAClose: 'Revoke_User_SIWA_Close',
  RevokeUserSIWA: 'Revoke_User_SIWA',
  CompleteRevokeUserSIWAClose: 'Complete_Revoke_User_SIWA_Close',
  SIWAAlertOpen: 'SIWA_Alert_Open',
  SIWAAlertClose: 'SIWA_Alert_Close',

  TermsOfService: 'Terms_Of_Service',
  PrivacyPolicy: 'Privacy_Policy',
  PrivacyPolicyForLocationInfo: 'Privacy_Policy_LocationInfo',
  AppStore: 'App_Store',
  CopyUrl: 'Copy_Url',

  PrevPage: 'Prev_Page',
  NextPage: 'Next_Page',
  PageChange: 'Page_Change',

  ToggleOpen: 'Toggle_Open',
  ToggleClose: 'Toggle_Close',

  Link: 'Link',
  ExternalLink: 'External_Link',
  ScrollToAnchorPoint: 'Scroll_To_Anchor_Point',

  HistoryBack: 'History_Back',
  Close: 'Close',

  ErrorRetry: 'Error_Retry',
  ErrorClose: 'Error_Close',

  VersionCheckClose: 'Version_Check_Close',

  PageView: 'Page_View'
}

export class FactoryTrack {
  /**
   * シールコレクション
   */
  static createSealCollection() {
    return {
      itemId: '',
      itemName: 'シールコレクション',
      contentsType: 'SealCollectio'
    }
  }
  /**
   * ガチャ
   */
  static createGachaList() {
    return {
      itemId: '',
      itemName: '香の川製麺ガチャ取引所',
      contentsType: 'Gacha_List'
    }
  }
  /**
   * ガチャFAQ
   */
  static createFAQGacha() {
    return {
      itemId: '',
      itemName: '香の川製麺ガチャって？',
      contentsType: 'FAQ_Gacha'
    }
  }
  /**
   * ご利用に関する注意事項
   */
  static createShowUsage() {
    return {
      itemId: '',
      itemName: 'ご利用に関する注意事項',
      contentsType: 'TakeOut'
    }
  }
    /**
   * 注文画面へ
   */
  static createWebOrder() {
    return {
      itemId: '',
      itemName: '注文画面へ',
      contentsType: 'TakeOut'
    }
  }

   /**
   * Home画面の近所のお店でタップ
   */
  static createInfoNearbyShops() {
    return {
      itemId: '',
      itemName: '近所のお店で',
      contentsType: 'Info_NearbyShops'
    }
  }
  /**
   * Home画面の宅配サービスタップ
   */
  static createInfoDelivery() {
    return {
      itemId: '',
      itemName: '宅配サービス',
      contentsType: 'Info_Delivery'
    }
  }
  /**
   * Home画面のネット通販タップ
   */
  static createInfoNetOrder() {
    return {
      itemId: '',
      itemName: 'ネット通販',
      contentsType: 'Info_NetOrder'
    }
  }
  /**
   * Home画面のテイクアウトタップ
   */
  static createInfoTakeOut() {
    return {
      itemId: '',
      itemName: 'テイクアウトWeb予約',
      contentsType: 'Info_TakeOut'
    }
  }
  /**
   * Home画面のSNSタップ
   */
  static createInfoSNS(type) {
    return {
      itemId: '',
      itemName: type,
      contentsType: 'Info_SNS'
    }
  }

  /**
   * Home画面のMenuタップ
   *
   * @param {string} id
   * @param {string} caption
   */
  static createInfoMenu(id, caption) {
    return { itemId: id, itemName: caption, contentsType: "Info_Menu" }
  }
  /**
   * 過去キャンペーン画面の過去のキャンペーンタップ
   *
   * @param {string} id
   * @param {string} caption
   * @param {string} type
   */
  static createPreviousSeal(id, name) {
    return { itemId: id, itemName: name, contentsType: "Previous_Seal" }
  }
  /**
   * Home画面のNewsパネルタップ
   *
   * @param {string} id
   * @param {string} caption
   * @param {string} type
   */
  static createInfoNews(id, caption, type) {
    return { itemId: id, itemName: caption, contentsType: type }
  }

  /**
   * Popup閉じるボタン
   *
   * @param {string} id
   * @param {string} caption
   */
  static createInfoPopupClose(id, caption) {
    return {
      itemId: id,
      itemName: caption,
      contentsType: ContentsType.InfoPopupClose
    }
  }

  /**
   * 外部URLへの遷移
   *
   * @param {string} id
   * @param {string} caption
   */
  static createInfoNewsExternalLink(id, caption) {
    return {
      itemId: id,
      itemName: caption,
      contentsType: ContentsType.InfoNewsExternalLink
    }
  }

  /**
   * Seal タップ
   *
   * @param {string} condition
   */
  static createSealCondition(isSelect) {
    return {
      itemId: '',
      itemName: isSelect,
      contentsType: ContentsType.SealCondition
    }
  }


  /**
   * クーポンの絞り込み条件
   *
   * @param {string} condition
   */
  static createCouponCondition(isSelect) {
    return {
      itemId: '',
      itemName: isSelect,
      contentsType: ContentsType.CouponCondition
    }
  }

  /**
   * クーポン
   *
   * @param {string} id
   * @param {string} caption
   */
  static createCoupon(id, caption) {
    return {
      itemId: id,
      itemName: caption,
      contentsType: ContentsType.CouponUse
    }
  }

  /**
   * フリーパス
   *
   * @param {string} id
   * @param {string} caption
   */
  static createFreepass(id, caption) {
    return {
      itemId: id,
      itemName: caption,
      contentsType: ContentsType.FreepassUse
    }
  }

  /**
   * クーポンを使う詳細
   *
   * @param {string} id
   * @param {string} caption
   */
  static createCouponDetail(id, caption) {
    return {
      itemId: id,
      itemName: caption,
      contentsType: ContentsType.CouponUseDetail
    }
  }

  /**
   * クーポンを利用する
   *
   * @param {string} id
   * @param {string} caption
   */
  static createUseCoupon(id, caption) {
    return {
      itemId: id,
      itemName: caption,
      contentsType: ContentsType.CouponUseConfirm
    }
  }

  /**
   * クーポン利用キャンセル
   * @param {string} id
   * @param {string} caption
   */
  static createCancelCoupon(id, caption) {
    return {
      itemId: id,
      itemName: caption,
      contentsType: ContentsType.CouponUseCancel
    }
  }

  /**
   * クーポン閉じる
   * @param {string} id
   * @param {string} caption
   */
  static createCouponClose(id, caption) {
    return {
      itemId: id,
      itemName: caption,
      contentsType: ContentsType.CouponClose
    }
  }

  /**
   * Profile
   *
   * @param {string} type
   */
  static createProfileUpdate() {
    return {
      itemId: '',
      itemName: 'プロフィール変更',
      contentsType: ContentsType.ProfileUpdate
    }
  }

  /**
   * アカウント登録
   */
  static createAccount() {
    return {
      itemId: '',
      itemName: 'アカウント登録',
      contentsType: ContentsType.Account
    }
  }
  /**
   * 基本設定
   */
  static createFAQBasic() {
    return {
      itemId: '',
      itemName: '基本設定',
      contentsType: ContentsType.FAQBasicSetting
    }
  }
  /**
   * スタンプを貯めよう
   */
  static createFAQCollectStamp() {
    return {
      itemId: '',
      itemName: 'スタンプを貯めよう',
      contentsType: ContentsType.FAQCollectStamp
    }
  }
  /**
   * クーポンを使ってみよう
   */
  static createFAQUseCoupon() {
    return {
      itemId: '',
      itemName: 'クーポンを使ってみよう',
      contentsType: ContentsType.FAQUseCoupon
    }
  }

  /**
   * スタンプがつかない
   */
  static createFAQStamp() {
    return {
      itemId: '',
      itemName: 'スタンプがつかない',
      contentsType: ContentsType.FAQHelpStamp
    }
  }

  static createFAQModelChange() {
    return {
      itemId: '',
      itemName: '機種変更時の注意点',
      contentsType: ContentsType.FAQModelChange
    }
  }
  static createFAQAndroid() {
    return {
      itemId: '',
      itemName: '●Android端末で最新版のアプリにアップデートできない',
      contentsType: ContentsType.FAQAndroid
    }
  }
  static createFAQNextAndroid() {
    return {
      itemId: '',
      itemName: '【重要】次回アップデートについて（Androidをお使いのお客様）',
      contentsType: ContentsType.FAQNextAndroid
    }
  }

  static createFAQPremium() {
    return {
      itemId: '',
      itemName: '香の川製麺プレミアムラウンジ',
      contentsType: ContentsType.FAQPremium
    }
  }

  static createFAQPremiumClose() {
    return {
      itemId: '',
      itemName: '香の川製麺プレミアムラウンジ',
      contentsType: ContentsType.FAQPremiumClose
    }
  }

  static createFAQStampSupport() {
    return {
      itemId: '',
      itemName: '●iOS端末でスタンプサポートが使えない',
      contentsType: ContentsType.FAQStampSupportBug
    }
  }

  static createFAQLineLogin() {
    return {
      itemId: '',
      itemName: 'LINE アカウント連携',
      contentsType: ContentsType.FAQLineLogin
    }
  }

  static createFAQSIWA() {
    return {
      itemId: '',
      itemName: 'Apple ID連携',
      contentsType: ContentsType.FAQSIWA
    }
  }

  static createFAQAcountDelete() {
    return {
      itemId: '',
      itemName: 'アプリアカウントを削除する',
      contentsType: ContentsType.FAQLineLogin
    }
  }
  /**
   * 読み込みエラーになる場合
   */
  static createFAQError() {
    return {
      itemId: '',
      itemName: '読み込みエラーになる場合',
      contentsType: ContentsType.FAQErrorHttp
    }
  }

  /**
   * よくあるご質問
   */
  static createFAQQuestions() {
    return {
      itemId: '',
      itemName: 'よくあるご質問',
      contentsType: ContentsType.FAQQuestions
    }
  }

  /**
   * 今すぐアプリ設定する
   */
  static createSettingApp() {
    return {
      itemId: '',
      itemName: '今すぐアプリ設定する',
      contentsType: ContentsType.SettingApp
    }
  }

  /**
   * 今すぐアプリ設定する 1
   */
  static createSettingApp1() {
    return {
      itemId: '',
      itemName: '今すぐアプリ設定する 1',
      contentsType: ContentsType.SettingApp1
    }
  }

  /**
   * 今すぐアプリ設定する 2
   */
  static createSettingApp2() {
    return {
      itemId: '',
      itemName: '今すぐアプリ設定する 2',
      contentsType: ContentsType.SettingApp2
    }
  }

  /**
   * 今すぐアプリ設定する 3
   */
  static createSettingApp3() {
    return {
      itemId: '',
      itemName: '今すぐアプリ設定する 3',
      contentsType: ContentsType.SettingApp3
    }
  }

  /**
   * メール送信
   * @param {string} caption
   */
  static createSendMail(caption) {
    return {
      itemId: '',
      itemName: caption,
      contentsType: ContentsType.SendMail
    }
  }

  /**
   * QRCamera
   */
  static createQRCamera() {
    return {
      itemId: '',
      itemName: 'QRカメラ',
      contentsType: ContentsType.QRCamera
    }
  }

  /**
   * スタンプサポート
   */
  static createStampSupport() {
    return {
      itemId: '',
      itemName: 'スタンプサポート',
      contentsType: ContentsType.StampSupport
    }
  }

  /**
   * クーポンを利用する
   */
  static createTryCoupon() {
    return {
      itemId: '',
      itemName: 'クーポンページへ移動',
      contentsType: ContentsType.GotoCoupon
    }
  }

  /**
   * 機種変更 ID送信
   */
  static createFAQModelChangeSendId() {
    return {
      itemId: '',
      itemName: 'IDをメールする',
      contentsType: ContentsType.ModelChangeSendId
    }
  }

  static createPrizes() {
    return {
      itemId: '',
      itemName: '特典一覧',
      contentsType: ContentsType.Prizes
    }
  }


  static createFAQLoginBonus() {
    return {
      itemId: '',
      itemName: 'ログインボーナスFAQ',
      contentsType: ContentsType.FAQLoginBonus
    }
  }
  static createFAQResetStamp() {
    return {
      itemId: '',
      itemName: 'スタンプリセットFAQ',
      contentsType: ContentsType.FAQResetStamp
    }
  }

  static createFAQiOS() {
    return {
      itemId: '',
      itemName: 'iOS端末で最新版のアプリにアップデートできない',
      contentsType: ContentsType.FAQiOS
    }
  }

  static createFAQiOS530() {
    return {
      itemId: '',
      itemName: 'iOS端末で最新版のアプリにアップデートできない',
      contentsType: ContentsType.FAQiOS530
    }
  }

  /**
   * シールコレクション
   */
  static createFAQSealCollection() {
    return {
      itemId: '',
      itemName: 'シールコレクション',
      contentsType: ContentsType.FAQSealCollection
    }
  }

  /**
   * アプリをお友達に紹介
   */
  static createFAQInvitation() {
    return {
      itemId: '',
      itemName: 'アプリをお友達に紹介',
      contentsType: ContentsType.FAQInvitation
    }
  }

  /**
   * ウォークスタンプ
   */
  static createFAQWalk() {
    return {
      itemId: '',
      itemName: 'ウォークスタンプ',
      contentsType: ContentsType.FAQWalk
    }
  }

  /**
   * ウォークスタンプ Q & A
   */
  static createFAQWalkQA() {
    return {
      itemId: '',
      itemName: 'ウォークスタンプ Q & A',
      contentsType: ContentsType.FAQWalkQA
    }
  }

  /**
   * お問い合わせ
   */
  static createFAQInquiry() {
    return {
      itemId: '',
      itemName: 'お問い合わせ',
      contentsType: ContentsType.FAQInquiry
    }
  }

  /**
   * 画面キャプチャ
   */
  static createGetScreenShot() {
    return {
      itemId: '',
      itemName: '画面キャプチャ',
      contentsType: ContentsType.GetScreenShot
    }
  }

  /**
   * ウォークスタンプ
   */
  static createWalk() {
    return {
      itemId: '',
      itemName: 'ウォークスタンプ',
      contentsType: ContentsType.Walk
    }
  }

  /**
   * ログインボーナス
   */
  static createLoginbonus() {
    return {
      itemId: '',
      itemName: 'ログインボーナス',
      contentsType: ContentsType.Loginbonus
    }
  }

  /**
   * ログインボーナス履歴
   */
  static createLoginbonusHistory() {
    return {
      itemId: '',
      itemName: 'ログインボーナス履歴',
      contentsType: ContentsType.LoginbonusHistory
    }
  }

  /**
   * 会員IDの引き継ぎ
   */
  static createDataInherit() {
    return {
      itemId: '',
      itemName: '会員IDの引き継ぎ',
      contentsType: ContentsType.DataInherit
    }
  }

  /**
   * 会員IDの入力
   */
  static createDataInheritInput() {
    return {
      itemId: '',
      itemName: '会員IDの入力',
      contentsType: ContentsType.DataInheritInput
    }
  }

  /**
   * 会員IDの引き継ぎ
   * @param {string} id
   */
  static createInheritUser(id) {
    return {
      itemId: id,
      itemName: 'アプリ会員IDでデータ引き継ぎ',
      contentsType: ContentsType.InheritUser
    }
  }

  /**
   * LINEログイン
   */
  static createLineLogin() {
    return {
      itemId: '',
      itemName: 'LINEログイン',
      contentsType: ContentsType.LineLogin
    }
  }

  /**
   * Sign in with Apple
   */
  static createSIWA() {
    return {
      itemId: '',
      itemName: 'AppleID連携',
      contentsType: ContentsType.LineLogin
    }
  }

  /**
   * ウォークスルー
   */
  static createWalkThrough() {
    return {
      itemId: '',
      itemName: 'ウォークスルー',
      contentsType: ContentsType.WalkThrough
    }
  }

  /**
   * ヘルプ・お問い合わせ
   * @param {number} index
   */
   static createFAQTop() {
    return {
      itemId: '',
      itemName: `ヘルプ・お問い合わせ`,
      contentsType: ContentsType.FAQTop
    }
  }

  /**
   * スタンプ獲得履歴
   * @param {number} index
   */
  static createStampHistory() {
    return {
      itemId: '',
      itemName: `スタンプ獲得`,
      contentsType: ContentsType.StampHistory
    }
  }

  /**
   * スタンプ獲得履歴詳細
   * @param {number} index
   */
  static createStampHistoryCard(index) {
    return {
      itemId: '',
      itemName: `スタンプ獲得履歴詳細 ${index}`,
      contentsType: ContentsType.StampHistoryCard
    }
  }

  /**
   * 月間スタンプランキング
   */
  static createStampHistoryMonthly() {
    return {
      itemId: '',
      itemName: '月間スタンプランキング',
      contentsType: ContentsType.StampHistoryMonthly
    }
  }

  /**
   * プレミアムラウンジ
   */
  static createPremiumCoupon() {
    return {
      itemId: '',
      itemName: 'プレミアムラウンジ',
      contentsType: ContentsType.PremiumCoupon
    }
  }

  /**
   * 許可に進む
   */
  static createToRegistration() {
    return {
      itemId: '',
      itemName: '許可に進む',
      contentsType: ContentsType.ToRegistration
    }
  }

  /**
   * 紹介成功アラート閉じる
   */
  static createInvitationSuccessClose() {
    return {
      itemId: '',
      itemName: '紹介成功アラート',
      contentsType: ContentsType.InvitationSuccessClose
    }
  }

  /**
   * 紹介失敗アラート閉じる
   */
  static createInvitationFailureClose() {
    return {
      itemId: '',
      itemName: '紹介失敗アラート',
      contentsType: ContentsType.InvitationFailureClose
    }
  }

  /**
   * 宅配サービス
   */
   static createDelivery() {
    return {
      itemId: '',
      itemName: '宅配サービス',
      contentsType: ContentsType.Delivery
    }
  }

  /**
   * テイクアウト
   */
   static createTakeOut() {
    return {
      itemId: '',
      itemName: 'テイクアウト',
      contentsType: ContentsType.TakeOut
    }
  }

  /**
   * ネット通販
   */
   static createNetorder() {
    return {
      itemId: '',
      itemName: 'ネット通販',
      contentsType: ContentsType.TakeOut
    }
  }


  /**
   * 削除完了
   */
   static createAccountDelete() {
    return {
      itemId: '',
      itemName: 'アカウント削除完了',
      contentsType: ContentsType.AccountDelete
    }
  }

  /**
   * 削除API送信
   */
   static createSendAccountDelete() {
    return {
      itemId: '',
      itemName: 'アカウント削除API送信',
      contentsType: ContentsType.SendAccountDelete
    }
  }

  /**
   * 削除アラート開く
   */
   static createAccountDeleteAlertOpen() {
    return {
      itemId: '',
      itemName: 'アカウント削除アラート開く',
      contentsType: ContentsType.AccountDeleteAlertOpen
    }
  }
  /**
   * 削除アラート閉じる
   */
  static createAccountDeleteAlertClose() {
    return {
      itemId: '',
      itemName: 'アカウント削除アラート',
      contentsType: ContentsType.AccountDeleteAlertClose
    }
  }

  /**
   * 紹介リンクアラート開く
   */
  static createInvitationAlertOpen() {
    return {
      itemId: '',
      itemName: '紹介リンクアラート開く',
      contentsType: ContentsType.InvitationAlertOpen
    }
  }

  /**
   * 紹介リンクアラート閉じる
   */
  static createInvitationAlertClose() {
    return {
      itemId: '',
      itemName: '紹介リンクアラート',
      contentsType: ContentsType.InvitationAlertClose
    }
  }

  /**
   * 紹介上限アラート閉じる
   */
  static createInvitationUpperLimitAlertClose() {
    return {
      itemId: '',
      itemName: '紹介上限アラート',
      contentsType: ContentsType.InvitationUpperLimitAlertClose
    }
  }

  /**
   * 紹介リンク送信
   */
  static createSendInvitation() {
    return {
      itemId: '',
      itemName: '紹介リンク送信',
      contentsType: ContentsType.SendInvitation
    }
  }

  /**
   * ウォークスタンプって？
   */
  static createAboutWalk() {
    return {
      itemId: '',
      itemName: 'ウォークスタンプって？',
      contentsType: ContentsType.AboutWalk
    }
  }

  /**
   * ウォークスタンプ更新
   */
  static createReloadWalk() {
    return {
      itemId: '',
      itemName: 'ウォークスタンプ更新',
      contentsType: ContentsType.ReloadWalk
    }
  }

  /**
   * ウォークスタンプ今週
   */
  static createThisWeekWalk() {
    return {
      itemId: '',
      itemName: 'ウォークスタンプ今週',
      contentsType: ContentsType.ThisWeekWalk
    }
  }

  /**
   * ウォークスタンプ週グラフ
   */
  static createWeeklyWalk() {
    return {
      itemId: '',
      itemName: 'ウォークスタンプ週グラフ',
      contentsType: ContentsType.WeeklyWalk
    }
  }

  /**
   * ウォークスタンプ月グラフ
   */
  static createMonthlyWalk() {
    return {
      itemId: '',
      itemName: 'ウォークスタンプ月グラフ',
      contentsType: ContentsType.MonthlyWalk
    }
  }

  /**
   * 宅配サービス
   * @param {string} caption
   */
  static createDeliveryService(caption) {
    return {
      itemId: '',
      itemName: `宅配サービス ${caption}`,
      contentsType: ContentsType.Delivery
    }
  }

  /**
   * ネットショップ
   * @param {string} caption
   */
  static createNetShop(caption) {
    return {
      itemId: '',
      itemName: `ネット通販 ${caption}`,
      contentsType: ContentsType.NetShop
    }
  }

  /**
   * ジョイちゃん
   */
  static createJoychan() {
    return {
      itemId: '',
      itemName: 'ジョイちゃん',
      contentsType: ContentsType.Joychan
    }
  }

  /**
   * メニュー
   */
  static createMenu() {
    return {
      itemId: '',
      itemName: 'メニュー',
      contentsType: ContentsType.Menu
    }
  }

  /**
   * LINEアカウント連携解除確認アラート表示
   */
  static createRevokeLineLoginOpen() {
    return {
      itemId: '',
      itemName: 'LINEアカウント連携解除確認',
      contentsType: ContentsType.RevokeLineLoginOpen
    }
  }

  /**
   * LINEアカウント連携解除
   */
  static createRevokeLineLogin() {
    return {
      itemId: '',
      itemName: 'LINEアカウント連携解除',
      contentsType: ContentsType.RevokeLineLogin
    }
  }

  /**
   * LINEアカウント連携解除確認アラート閉じる
   */
  static createRevokeLineLoginClose() {
    return {
      itemId: '',
      itemName: 'LINEアカウント連携解除確認',
      contentsType: ContentsType.RevokeLineLoginClose
    }
  }

  /**
   * LINEアカウント連携解除完了アラート閉じる
   */
  static createCompleteRevokeLineLoginClose() {
    return {
      itemId: '',
      itemName: 'LINEアカウント連携解除完了',
      contentsType: ContentsType.CompleteRevokeLineLoginClose
    }
  }

  /**
   * SIWA連携解除確認アラート表示
   */
  static createRevokeUserSIWAOpen() {
    return {
      itemId: '',
      itemName: 'AppleID連携解除確認開く',
      contentsType: ContentsType.RevokeUserSIWAOpen
    }
  }

  /**
   * SIWA連携解除確認アラート閉じる
   */
  static createRevokeUserSIWAClose() {
    return {
      itemId: '',
      itemName: 'AppleID連携解除確認閉じる',
      contentsType: ContentsType.RevokeLineLoginClose
    }
  }

  /**
   * SIWA連携解除
   */
  static createRevokeUserSIWA() {
    return {
      itemId: '',
      itemName: 'AppleID連携解除',
      contentsType: ContentsType.RevokeLineLogin
    }
  }

  /**
   * SIWA連携解除完了アラート閉じる
   */
  static createCompleteRevokeUserSIWAClose() {
    return {
      itemId: '',
      itemName: 'AppleID連携解除完了',
      contentsType: ContentsType.CompleteRevokeLineLoginClose
    }
  }

  /**
   * 利用規約
   */
  static createTermsOfService() {
    return {
      itemId: '',
      itemName: '利用規約',
      contentsType: ContentsType.TermsOfService
    }
  }

  /**
   * 個人情報保護方針
   */
  static createPrivacyPolicy() {
    return {
      itemId: '',
      itemName: '個人情報保護方針',
      contentsType: ContentsType.PrivacyPolicy
    }
  }

  /**
   * 位置情報に関する個人情報保護方針
   */
   static createPrivacyPolicyForLocationInfo() {
    return {
      itemId: '',
      itemName: '位置情報に関する個人情報保護方針',
      contentsType: ContentsType.PrivacyPolicyForLocationInfo
    }
  }

  /**
   * App Store
   */
  static createAppStore() {
    return {
      itemId: '',
      itemName: 'App Store',
      contentsType: ContentsType.AppStore
    }
  }

  /**
   * URLコピー
   */
  static createCopyUrl() {
    return {
      itemId: '',
      itemName: 'URLコピー',
      contentsType: ContentsType.CopyUrl
    }
  }

  /**
   * ページ前へ
   * @param {string} caption
   * @param {number} pageNumber
   */
  static createPrevPage(caption, pageNumber) {
    return {
      itemId: '',
      itemName: `${caption} ${pageNumber}`,
      contentsType: ContentsType.PrevPage
    }
  }

  /**
   * ページ次へ
   * @param {string} caption
   * @param {number} pageNumber
   */
  static createNextPage(caption, pageNumber) {
    return {
      itemId: '',
      itemName: `${caption} ${pageNumber}`,
      contentsType: ContentsType.NextPage
    }
  }

  /**
   * ページ変更
   * @param {string} caption
   * @param {number} pageNumber
   */
  static createPageChange(caption, pageNumber) {
    return {
      itemId: '',
      itemName: `${caption} ${pageNumber}`,
      contentsType: ContentsType.PageChange
    }
  }

  /**
   * トグル開く
   * @param {string} caption
   */
  static createToggleOpen(caption) {
    return {
      itemId: '',
      itemName: caption,
      contentsType: ContentsType.ToggleOpen
    }
  }

  /**
   * トグル閉じる
   * @param {string} caption
   */
  static createToggleClose(caption) {
    return {
      itemId: '',
      itemName: caption,
      contentsType: ContentsType.ToggleClose
    }
  }

  /**
   * アプリ内遷移
   * @param {string} caption
   */
  static createLink(caption) {
    return {
      itemId: '',
      itemName: caption,
      contentsType: ContentsType.Link
    }
  }

  /**
   * 外部遷移
   * @param {string} caption
   */
  static createExternalLink(caption) {
    return {
      itemId: '',
      itemName: caption,
      contentsType: ContentsType.ExternalLink
    }
  }

  /**
   * ページ内参照
   * @param {string} caption
   */
  static createScrollToAnchorPoint(caption) {
    return {
      itemId: '',
      itemName: caption,
      contentsType: ContentsType.ScrollToAnchorPoint
    }
  }

  /**
   * 戻る
   */
  static createHistoryBack() {
    return {
      itemId: '',
      itemName: '戻る',
      contentsType: ContentsType.HistoryBack
    }
  }

  /**
   * 閉じる
   * @param {string} caption
   */
  static createClose(caption) {
    return {
      itemId: '',
      itemName: caption,
      contentsType: ContentsType.Close
    }
  }

  /**
   * エラーリトライ
   */
  static createErrorRetry() {
    return {
      itemId: '',
      itemName: 'リトライ',
      contentsType: ContentsType.ErrorRetry
    }
  }

  /**
   * エラー閉じる
   */
  static createErrorClose() {
    return {
      itemId: '',
      itemName: 'エラー',
      contentsType: ContentsType.ErrorClose
    }
  }

  /**
   * バージョンチェックアラート閉じる
   */
  static createVersionCheckClose() {
    return {
      itemId: '',
      itemName: 'バージョンチェックアラート',
      contentsType: ContentsType.VersionCheckClose
    }
  }

  /**
   * Page View
   * @param {Route} route
   * @param {Store} store
   */
  static createPageView(route, store) {
    let id = null
    if (route.path === '/home/news') {
      const news = store.getters['Home/detailNews']
      if (news) {
        id = news.id
      }
    }
    return {
      itemId: route.name || route.path,
      itemName: id !== null ? `${route.fullPath}/${id}` : route.fullPath,
      contentsType: ContentsType.PageView
    }
  }
}
